(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}
		hide() {
			super.hide();
			window.pauseAllMedia();
		}
		show(opener) {
			super.show(opener);
			//this.showActiveMedia();
			this.constProductPageSwiperCall()
		}
		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();
			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}			
		constProductPageSwiperCall(showActiveMedia) {
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			let activeMediaIndex = 0
			
			this.querySelectorAll(`.swiper-slide`).forEach((element, index) => {
					if(element == activeMedia){
						activeMediaIndex = index
					}
				}
			)
			const prodPageSwiper = new Swiper("#featured-product-swiper", {
				zoom: true,
				centeredSlides: false,
				slidesPerView: 1,
				autoheight: true,
				watchSlidesVisibility: false,
				watchSlidesProgress: true,
				observer: true,
				observeParents: true,
				init: false,
				navigation: {
					nextEl: ".swiper-button-next-prod-page",
					prevEl: ".swiper-button-prev-prod-page",
				}
			});
			prodPageSwiper.on('init', function() {
				prodPageSwiper.slideTo(activeMediaIndex, 0, false);
			});
			prodPageSwiper.init()
			document.querySelector('.product-media-modal__toggle').addEventListener("click", function(){ prodPageSwiper.destroy() });
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}
			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.headerId = document.getElementById("section-header").getAttribute('data-header-id');
		this.header = document.getElementById(`shopify-section-${this.headerId}`);
		this.headerBounds = {};
		this.currentScrollTop = 0;

		this.onScrollHandler = this.onScroll.bind(this);

		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.hide.bind(this));
		if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
			this.predictiveSearch.onFocusOut();
			this.predictiveSearch.onBlur();
		} 
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		requestAnimationFrame(this.reveal.bind(this));
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}
	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    


class ProductModal extends ModalDialog {
	constructor() {
		super();
	}
	hide() {
		super.hide();
		window.pauseAllMedia();
	}
	show(opener) {
		super.show(opener);
		//this.showActiveMedia();
		this.constProductPageSwiperCall()
	}
	showActiveMedia() {
		this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
			}
		)
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		activeMedia.classList.add('active');
		activeMedia.scrollIntoView();
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
	
constProductPageSwiperCall(showActiveMedia) {
	const swiperContainer = document.getElementById("product-page-swiper");
	if (!swiperContainer) return;

	const slides = swiperContainer.querySelectorAll(".swiper-slide[data-media-id]");
	if (!slides.length) return;

	const openedId = this?.openedBy?.getAttribute("data-media-id");
	const fallbackFirst = slides[0];
	const targetId = openedId || fallbackFirst?.getAttribute("data-media-id");

	let activeMediaIndex = 0;
	if (targetId) {
		slides.forEach((element, index) => {
			if (element.getAttribute("data-media-id") === targetId) {
				activeMediaIndex = index;
			}
		});
	}

	activeMediaIndex = Math.max(0, Math.min(activeMediaIndex, slides.length - 1));

	// Initialize the product page swiper
	const prodPageSwiper = new Swiper("#product-page-swiper", {
		loop: true,
		zoom: {
			maxRatio: 2,
			minRatio: 1,
			toggle: false, // disable global double-tap zoom
			panOnMouseMove: false,
		},
		slidesPerView: 1,
		centeredSlides: false,
		speed: 0,
		observer: true,
		observeParents: true,
		init: false,
		navigation: {
			nextEl: ".swiper-button-next-prod-page",
			prevEl: ".swiper-button-prev-prod-page",
		},
		pagination: {
			el: ".swiper-pagination-product-page",
			clickable: true,
		},
		breakpoints: {
			// Desktop breakpoint (>= 767px)
			767: {
				direction: "horizontal",
				mousewheel: false,
				zoom: {
					enabled: false,
				},
			},
			// Mobile breakpoint (< 767px)
			0: {
				direction: "vertical",
				mousewheel: {
					sensitivity: 1,
					thresholdDelta: 50,
					forceToAxis: true,
					enabled: true,
				},
				zoom: {
					enabled: true,
					maxRatio: 2,
					minRatio: 1,
					toggle: false, // ❌ Disable double-tap zoom
				},
				freeMode: true,
				freeModeMomentum: true,
				freeModeMomentumBounce: true,
				grabCursor: true,
				allowTouchMove: true,
				a11y: true,
				touchReleaseOnEdges: true,
				resistance: true,
				resistanceRatio: 0.85,
			},
		},
		on: {
			init: function () {
				const swiper = this;

				requestAnimationFrame(() => {
					// Slide to the active media index
					if (swiper.params.loop) {
						swiper.slideToLoop(activeMediaIndex, 0, false);
					} else {
						swiper.slideTo(activeMediaIndex, 0, false);
					}

					// Ensure zoom is reset on init
					if (window.innerWidth < 767 && swiper.zoom) {
						setTimeout(() => {
							swiper.zoom.in();
						}, 100);
					}
				});
			},

			slideChangeTransitionEnd: function () {
				if (window.innerWidth < 767) {
					const swiper = this;
					swiper.zoom.out(); // reset previous zoom state
					swiper.zoom.in();  // then apply zoom to new slide
				}
			},
		},
	});

	// Initialize the swiper
	prodPageSwiper.init();

	const modalToggle = document.querySelector(".product-media-modal__toggle");
	if (modalToggle) {
		modalToggle.addEventListener("click", () => {
			if (prodPageSwiper && !prodPageSwiper.destroyed) {
				prodPageSwiper.destroy(true, true);
			}
		});
	}
};



}

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then(response => response.text())
				.then(text => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations--single');
					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
                      
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
	}
}

customElements.define('product-modal', ProductModal);
customElements.define('product-recommendations--single', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              const new_grid_img_gallery = document.querySelectorAll(
                '.product-recommendations__item .image-grid-gallery'
              );

              if (new_grid_img_gallery.length) {
                new_grid_img_gallery.forEach(function (el, index) {
                  el.classList.add(`s${index}`);

                  const swipers = new Swiper(`.image-grid-gallery.s${index}`, {
                    noTransition: true,
                    effect: 'fade',
                    spaceBetween: 0,
                    loop: true,
                    autoplay: false,
                    navigation: {
                      nextEl: document.querySelector(`.image-grid-gallery.s${index} .swiper-button-next`),
                      prevEl: document.querySelector(`.image-grid-gallery.s${index} .swiper-button-prev`),
                    },
                  });

                  // ✅ iOS tap fix — make first click work
                  let touchStartX = 0;
                  let touchStartY = 0;

                  el.addEventListener('touchstart', (e) => {
                    const t = e.changedTouches[0];
                    touchStartX = t.clientX;
                    touchStartY = t.clientY;
                  });

                  el.addEventListener('touchend', (e) => {
                    const t = e.changedTouches[0];
                    const dx = Math.abs(t.clientX - touchStartX);
                    const dy = Math.abs(t.clientY - touchStartY);

                    // Only treat as click if no real swipe happened
                    if (dx < 10 && dy < 10) {
                      const link = e.target.closest('a');
                      if (
                        link &&
                        !e.target.closest('.swiper-button-next') &&
                        !e.target.closest('.swiper-button-prev')
                      ) {
                        window.location.href = link.href;
                      }
                    }
                  });

                  // 🖱 Desktop hover behavior
                  if ($(window).width() < 768) {
                    // mobile behavior (currently commented out)
                  } else {
                    el.addEventListener('mouseover', (event) => {
                      if (swipers.activeIndex == 1) {
                        swipers.slideTo(2, 0, false);
                        swipers.update();
                      }
                    });

                    el.addEventListener('mouseout', (event) => {
                      if (swipers.activeIndex == 2) {
                        swipers.slideTo(1, 0, false);
                        swipers.update();
                      }
                    });
                  }
                });
              }

              document.querySelectorAll('.product-look-plus-icon').forEach(function (element) {
                element.addEventListener('click', function () {
                  const dataId = element.getAttribute('data-id');
                  var productDataDiv = document.querySelector('.look_related_products_' + dataId);
                  productDataDiv.classList.add('show');
                  var overlay = document.querySelector('.PageOverlay');
                  overlay.classList.add('is-visible');
                  document.querySelector('html').style.overflow = 'hidden';
                  overlay.addEventListener('click', function () {
                    overlay.classList.remove('is-visible');
                    overlay.classList.remove('cart-overlay');
                    productDataDiv.classList.remove('show');
                    document.querySelector('html').style.overflow = 'auto';
                  });
                });
              });

              document.querySelectorAll('.close-view').forEach(function (element) {
                element.addEventListener('click', function () {
                  const productDataDiv = element.closest('.look_related_products');
                  if (productDataDiv) {
                    productDataDiv.classList.remove('show');
                    document.querySelector('.PageOverlay.is-visible').classList.remove('is-visible');
                    document.querySelector('html').style.overflow = 'auto';
                  }
                });
              });
              document
                .querySelectorAll('.product-recommendations__item .option_swatch_radio')
                .forEach(function (radio) {
                  if (!radio.disabled) {
                    radio.addEventListener('click', function () {
                      var variantId = this.getAttribute('data-variant-id');
                      console.log('Clicked radio with variant ID:', variantId);
                      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                      const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

                      const body = JSON.stringify({
                        id: variantId,
                        quantity: 1,
                        sections: sections,
                        sections_url: window.location.pathname,
                      });

                      fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
                        .then((response) => response.json())
                        .then((response) => {
                          console.log(response, 'response');
                          if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                          }
                          if (
                            document.querySelector(
                              '.product-recommendations__item ul.quick__add-List__Items-wrapper'
                            ) &&
                            document
                              .querySelector('.product-recommendations__item ul.quick__add-List__Items-wrapper')
                              .classList.contains('drag-swatch')
                          ) {
                            document
                              .querySelector(
                                '.product-recommendations__item ul.quick__add-List__Items-wrapper.drag-swatch'
                              )
                              .classList.remove('drag-swatch');
                            document.querySelector('.PageOverlay.is-visible').classList.remove('is-visible');
                          }
                          if (radio.classList.contains('look-item')) {
                            radio.closest('.look_related_products').classList.remove('show');
                          }
                          this.cart.renderContents(response);
                        });
                    });
                  }
                });

              var plus = document.querySelectorAll('.product-recommendations__item .plus-icon');
              plus.forEach((link) => {
                if (!link.classList.contains('one-size')) {
                  link.addEventListener('click', toggleOverlaypro);
                  if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                    link.addEventListener('touchend', toggleOverlaypro);
                    link.style.touchAction = 'manipulation';
                  }
                }
              });

              function toggleOverlaypro() {
                var size_swatch = this.closest('.card-wrapper').querySelector('.quick__add-List__Items-wrapper');
                size_swatch.classList.add('drag-swatch');
                var overlay = document.querySelector('.PageOverlay');
                overlay.classList.add('is-visible');
                document.querySelector('html').style.overflow = 'hidden';
                overlay.addEventListener('click', function () {
                  overlay.classList.remove('is-visible');
                  overlay.classList.remove('cart-overlay');
                  size_swatch.classList.remove('drag-swatch');
                  document.querySelector('html').style.overflow = 'auto';
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
